import { render, staticRenderFns } from "./Cokteles.vue?vue&type=template&id=867b09fa&scoped=true&"
import script from "./Cokteles.vue?vue&type=script&lang=js&"
export * from "./Cokteles.vue?vue&type=script&lang=js&"
import style0 from "./Cokteles.vue?vue&type=style&index=0&id=867b09fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867b09fa",
  null
  
)

export default component.exports